<template>
	<div class="main" style="">
			<div class="__row-swiper">
				<!-- <el-carousel height="404px">
					<el-carousel-item class="new-swiper-item" v-for="(item,index) in carousellist_head" :key="item.id">
						<div class="el-image swiper-img w100">
							<img :src="item.imgPath" class="el-image__inner" style="object-fit: cover;width: 100%;">
						</div>
					</el-carousel-item>
				</el-carousel> -->
				  <el-carousel height="600px" indicator-position="outside">
				    <el-carousel-item v-for="item in carousellist_head">
						<div class="el-image swiper-img w100">
							<img :src="imgurl+ item.imgPath" width="100%" height="600px">
							<div class="banner_text">
								<div>企业信息化专业集成商</div>
								<!-- <div>10年服务经验积累，9种安全保障，8种服务场景，优质服务值得您信赖</div> -->
								<div>
									{{item.remark}}
								</div>
							</div>
						</div>
				    </el-carousel-item>
				  </el-carousel>
			</div>

			<div class="container">
				<div v-for="(item,index) in modulesList">
					
					<div v-if="index%2==0" class="container_item" >
						<div class="item_text">
							<div style="font-size:28px; color:#101010;line-height: 41px;">{{item.name}}</div>
							<div style="font-size: 18px; color:#AEAEAE;line-height: 27px;margin-top: 13px;">{{item.title}}</div>
							<div style="font-size: 18px; color:#101010;line-height: 27px;margin-top: 25px;">{{item.description}}</div>
							<div style="margin-top: 50px;">
								<div style="width: 160px;height: 50px;border: 1px solid #3894FF;align-items: flex-start;border-radius: 4px; text-align: center;">
									<router-link class="route_item" :to="`${item.uri}`">了解更多</router-link>
									<!-- <a href="" style="text-decoration: none; color: #3894FF;font-size: 14px;line-height: 50px;">了解更多</a> -->
								</div>
							</div>
						</div>
						<img class="item_img" :src="imgurl + item.img" height="415px" width="700" alt="">
					</div>
					<div v-if="index%2!==0" class="container_item">
						<img class="item_img" :src="imgurl + item.img" height="415px" width="700" alt="">
						<div class="item_text">
							<div style="font-size:28px; color:#101010;line-height: 41px;">{{item.name}}</div>
							<div style="font-size: 18px; color:#AEAEAE;line-height: 27px;margin-top: 13px;">{{item.title}}</div>
							<div style="font-size: 18px; color:#101010;line-height: 27px;margin-top: 25px;">{{item.description}}</div>
							<div style="margin-top: 50px;">
								<div style="width: 160px;height: 50px;border: 1px solid #3894FF;align-items: flex-start;border-radius: 4px; text-align: center;">
									<router-link class="route_item" :to="`${item.uri}`">了解更多</router-link>
									<!-- <a href="" style="text-decoration: none; color: #3894FF;font-size: 14px;line-height: 50px;">了解更多</a> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- <div class="img_show" style="padding-top: 50px;padding-bottom: 100px; background-color: #F2F2F2;">
				<div style="font-size: 28px;color: #101010;text-align: center;">这些行业都可以用我们</div>
				<div style="display: flex;justify-content: space-between; width: 1200px;margin: 55px auto; flex-wrap: wrap;">
					<img src="/banner02.jpg" alt="" height="160" width="auto" style="margin-bottom: 20px;">
					<img src="/01.png" alt="" height="160" width="auto">
					<img src="/01.png" alt="" height="160" width="auto">
					<img src="/01.png" alt="" height="160" width="auto">
					<img src="/01.png" alt="" height="160" width="auto">
					<img src="/banner02.jpg" alt="" height="160" width="auto">
				</div>
			</div> -->
			<div class="img_show" style="padding-top: 50px;padding-bottom: 100px;">
				<div style="font-size: 28px;color: #101010;text-align: center;">企业荣誉</div>
				<div style="" class="honour_container">
					<template v-for="(item,index) in enterpriseHonor">
						<div>
							<img class="img_hover" :src="imgurl + item.img" alt="" width="auto" @click="previewImage(imgurl + item.img)">
						</div>
					</template>
				</div>
			</div>
			<div v-if="previewVisible" class="modal" @click="closePreview">
				<img :src="previewImageSrc" alt="预览图片" class="modal-img">
			</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		imgurl,getAction
	} from "@/api/manage";

	export default {
		name: 'HelloWorld',
		props: {
			msg: String
		},
		data() {
			return {
				previewVisible: false,
				previewImageSrc: '',
				imgurl: imgurl,
				
				url:{
					getShowList: 'viwo/indexRotation/getShowList',//首页轮播图
					getModulesList: 'viwo/homeModules/getList',//首页模块
					getNewsList: "bljg/news/getList",
					getGsggList: "bljg/compNotice/getList",
					getTzggList: "bljg/compInform/getList",
					getGhlist: "bljg/compUnions/getList",
					getGszdList: "bljg/compSystem/getList",
					getLxfsList: "bljg/companyInfo/getMainInfo",
					getGcalList: "bljg/engCase/getList",
					getZjgcList: "bljg/engRunning/getList",
				},
				
				content_lxfs: "",
				
				carousellist_head:[
					{
						imgPath:'/banner02.jpg'
					},
					// {
					// 	imgPath:'/banner02.jpg'
					// }
				],
				modulesList:[],
				enterpriseHonor:[],
				

			}
		},
		mounted() {
			this.getShowList()
			this.getModulesList()
			this.getEnterpriseHonor()
		},
		created() {
			
		},
		methods: {
			previewImage(src) {
				this.previewImageSrc = src;
				this.previewVisible = true;
			},
			closePreview() {
				this.previewVisible = false;
			},
			getEnterpriseHonor() {
				let that = this;
				let param = {
					type:'企业荣誉'
				};
				getAction("viwo/aboutUs/getList", param).then(res => {
					if (res.success && res.result) {
						that.enterpriseHonor = res.result.records;
						console.log("公司信息res===",res)
					}
				})
			},
			getShowList(){
				let that = this;
				let param = {};
				getAction(this.url.getShowList, param).then(res => {
					if (res.success && res.result) {
						that.carousellist_head = res.result;
						console.log("轮播图res===",res)
					}
				})
			},
			getModulesList() {
				let that = this;
				let param = {};
				getAction(this.url.getModulesList, param).then(res => {
					if (res.success && res.result) {
						that.modulesList = res.result;
						console.log("模块res===",res)
					}
				})
			}

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.w100 {
		width: 100%;
		position: relative;
	}

	.nav-container {
		background-color: #0061AE;
	}

	.flex-align-center {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.flex-row-center {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.main {
		// min-height: calc(100vh - 350px);
		width:1440px;
		margin: 0 auto; 
		min-height: 1426px;

	}


	.el-image__inner {
		vertical-align: top;
	}

	.__row-swiper {
		width: 100%;
		height: 700px;
	}


	.row-space {
		display: flex;
		justify-content: space-between;
	}

	.__tab-ctr-full {
		justify-content: space-around;

		.tab-item {
			font-size: 14px;
			font-weight: bold;
			color: #111;
			position: relative;
			cursor: pointer;
			height: 50px;
			align-items: center;
			justify-content: center;
			border: 3px solid #fff;
			border-top-color: #0061AE;
			border-left: none;
			border-right: none;
			flex-grow: 1;
		}

		.tab-item.active,
		.tab-item:hover {
			color: #fff;
			background: #0061AE;
			border-color: #0061AE;
		}
	}

	.__contact-us {
		width: 290px;
		background-color: #fff;
		height: 314px;
		display: flex;
		flex-direction: column;
	}

	.top {
		width: 290px;
		height: 133px;
		flex-shrink: 0;
	}

	img {
		border: none;
		vertical-align: middle;
	}

	.info {
		width: 272px;
		font-size: 14px;
		font-weight: 500;
		color: #333;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		padding: 10px;
		user-select: text;
		-webkit-user-select: text;
		-moz-user-select: text;
		-ms-user-select: text;
	}



	.__image-list {
		width: 100%;
		height: 292px;
	}

	.flex-col-center {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.__tab-ctr-line {
		justify-content: flex-start;

		.tab-item {
			margin: 0 15px;
			width: 135px;
			font-size: 14px;
			font-weight: bold;
			color: #111;
			position: relative;
			cursor: pointer;
		}

		.tab-item.active,
		.tab-item:hover {
			color: #0061AE;
		}

		.tab-item .label {
			padding: 0 4px 14px 4px;
		}

		.tab-item.active .line,
		.tab-item:hover .line {
			visibility: visible;
			height: 3px;
			width: 100%;
			background-color: #0061AE;
			position: absolute;
			bottom: 0;
		}
	}


	.swiper-img2 {
		width: 286px;
		height: 196px;
		border-radius: 10px;
		margin: 0 6px;
		cursor: pointer;
	}

	.swiper-img2:hover {
		filter: brightness(135%);
	}

	.firends-link {
		display: flex;
		align-content: center;
		width: 1200px;
		min-height: 50px;
		background: #fff;
		border: 1px solid #dcdcdc;
		padding: 0 17px;
		flex-wrap: wrap;

		.title {
			color: #333;
			font-weight: 700;
			font-size: 14px;
			line-height: 50px;
		}

		.link-item {
			cursor: pointer;
			font-size: 12px;
			margin-right: 20px;
			line-height: 50px;
		}

		.link-item:hover {
			color: #0061AE;
		}
	}
	
	  .el-carousel__item h3 {
	    color: #475669;
	    font-size: 18px;
	    opacity: 0.75;
	    line-height: 300px;
	    margin: 0;
	  }
	  
	  .el-carousel__item:nth-child(2n) {
	    background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	    background-color: #d3dce6;
	  }
	  
	  .banner_text{
		  position: absolute;
		  left: 0px;
		  top: 0px;
		  width: 824px;
		  height: 600px;
		  // line-height: 20px;
		  background-color: rgba(56,148,255,0.5);
		  color: rgba(16,16,16,1);
		  font-size: 14px;
		  // text-align: center;
		  display: flex;
		  flex-direction: column;
		  justify-content: center;
		  font-family: SourceHanSansSC-regular;
		  
		  div:first-child{
		  		font-size: 60px;  
		  		color: #fff;
				width: 600px;
				margin-left: 120px;
		  }
		  div:last-child{
		  		// font-size: 20px;  
		  		// color: #fff;
				margin-left: 120px;
				width: 445px;
				// text-align: center;
				height: 63px;
				line-height: 29px;
				color: rgba(255,255,255,1);
				font-size: 20px;
				font-family: SourceHanSansSC-regular;
		  }
		  
	  }
	  
	  .el-carousel__container {
		  height: 600px;
	  }
	  .container_item {
		  display: flex;
		  margin: 0 120px;
		  margin-bottom: 110px;
		  justify-content: space-between;
	  }
	  
	  .item_text {
		  font-family: SourceHanSansSC-regular;
		  width: 414px;
		  height: 415px;
		  // flex: 1;
		  display: flex;
		  flex-direction: column;
		  justify-content: center;
		  // align-items: center;
		  div{
			  
			  width: 414px;
			  
		  }
	  }
	  
	  
	// .honour_container {
	// 	display: flex; 
	// 	// width: 1200px;
	// 	width: calc(25% * 4);
	// 	margin: 55px auto; 
	// 	justify-content: space-between;
	// 	flex-wrap: wrap;
	// 	div {
	// 	  flex: 0 0 25%; /* 每个盒子占25%宽度 */
	// 	  box-sizing: border-box; /* 包含边框和内边距 */
	// 	  padding: 10px; /* 内边距 */
	// 	  border: 1px solid #ccc; /* 边框 */
	// 	}
	// }
	.honour_container {
	  display: flex;
	  flex-wrap: wrap;
	  width: 1200px;
	  margin: 50px auto 20px;
	  gap:55px; /* 统一控制盒子间距 */
	  justify-content: space-between; /* 水平居中布局 */
	  div {
	    flex: 0 0 calc(18% - 55px); 
	    box-sizing: border-box; /* 包含边框/内边距 */
	    border: 1px solid #ddd;
		height: 160px;
		display: flex;
		justify-content: center;
		align-items: center;
	  }
	}
	::v-deep .container_item:nth-of-type(even) {
		justify-content: ;
	}
	.route_item {
		text-decoration: none;
		line-height: 52px;
		color: #3894ff;
	}
	.img_hover {
		height:120px; 
	}
	// .img_hover:hover {
	// 	transition: transform 0.5s ease;
	// 	 transform: scale(1.3)/* Smooth transition for the zoom effect */
	// } 
	
	.modal {
	  position: fixed;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  background: rgba(0, 0, 0, 0.7);
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  z-index: 1000;
	}
	.modal-img {
	  max-width: 90%;
	  max-height: 90%;
	  cursor: pointer;
	}
	.img_hover {
	  cursor: pointer;
	  margin: 10px;
	}
</style>